const lfidUrl = 'https://lfid.clientctx.su/lfid.min.js';

function loadScript(
    src, onLoad, onError,
) {
    // проверяем, есть ли уже скрипт с lfid
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
        return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = onLoad;
    script.onerror = onError;
    script.defer = true;
    document.head.appendChild(script);
}

function initLfid(trackingDomain) {
    if (window.leadsFp) {
        window.leadsFp({
            enhanceLinks: true,
            trackingDomain: trackingDomain,
        });
    }
}

function loadLfid(trackingDomain) {
    loadScript(
        lfidUrl,
        () => initLfid(trackingDomain),
        () => {},
    );
}

export default loadLfid;
